// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2st5p","amount":"Amount_amount__1Itko","tip":"Amount_tip__X6meR","tipHeader":"Amount_tipHeader__2Rj5R","tipsWrap":"Amount_tipsWrap__14iV1"};